var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teaching-score-input-merge"},[(_vm.elective.scoreMergeLuru)?_c('span',{class:['value', _vm.computeState]},[_vm._v(_vm._s(_vm.elective.scoreMergeLuru))]):_c('span',{staticClass:"empty"},[_vm._v(_vm._s(_vm.emptyText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }